import {APP_PREFIX_PATH} from "../AppConfig";
import React from "react";

export const userViewRoutes = [
    // KARTU REGISTRASI
    {
        key: 'kartu-registrasi',
        path: `${APP_PREFIX_PATH}/kartu-registrasi`,
        component: React.lazy(() => import('views/user-views/kartu-registrasi')),
    },
    {
        key: 'kartu-registrasi-show',
        path: `${APP_PREFIX_PATH}/kartu-registrasi-show`,
        component: React.lazy(() => import('views/user-views/kartu-registrasi/show')),
    },
    {
        key: 'kartu-registrasi-list',
        path: `${APP_PREFIX_PATH}/kartu-registrasi-list`,
        component: React.lazy(() => import('views/user-views/kartu-registrasi/list')),
    },
    {
        key: 'kartu-registrasi-edit',
        path: `${APP_PREFIX_PATH}/kartu-registrasi-list/edit`,
        component: React.lazy(() => import('views/user-views/kartu-registrasi/list/edit')),
    },
    {
        key: 'kartu-registrasi-detail',
        path: `${APP_PREFIX_PATH}/kartu-registrasi-list/view`,
        component: React.lazy(() => import('views/user-views/kartu-registrasi/list/view/ViewData')),
    },
    {
        key: 'kartu-registrasi-reg-ulang',
        path: `${APP_PREFIX_PATH}/kartu-registrasi-list/reg-ulang`,
        component: React.lazy(() => import('views/user-views/kartu-registrasi/list/reg-ulang')),
    },
    {
        key: 'kartu-registrasi-download',
        path: `${APP_PREFIX_PATH}/kartu-registrasi-list/download`,
        component: React.lazy(() => import('views/user-views/kartu-registrasi/list/download')),
    },

    // PENDAFTARAN
    {
        key: 'pendaftaran',
        path: `${APP_PREFIX_PATH}/pendaftaran`,
        component: React.lazy(() => import('views/user-views/pendaftaran/show')),
    },
    {
        key: 'registrasi.show',
        path: `${APP_PREFIX_PATH}/pendaftaran-show`,
        component: React.lazy(() => import('views/user-views/pendaftaran/step-pendaftaran')),
    },
    {
        key: 'registrasi.daftar',
        path: `${APP_PREFIX_PATH}/pendaftaran/daftar`,
        component: React.lazy(() => import('views/user-views/pendaftaran/show')),
    },
    {
        key: 'pemdaftaran.daftar.mhs',
        path: `${APP_PREFIX_PATH}/daftar/mhs`,
        component: React.lazy(() => import('views/user-views/daftar')),
    },
    // PENDAFTARAN V2
    {
        key: 'pendaftaran.mahasiswa',
        path: `${APP_PREFIX_PATH}/pendaftaran-mahasiswa`,
        component: React.lazy(() => import('views/v2/user/pendaftaran')),
    },
    {
        key: 'pendaftaran.mahasiswa.biodata',
        path: `${APP_PREFIX_PATH}/pendaftaran-mahasiswa/biodata`,
        component: React.lazy(() => import('views/v2/user/pendaftaran/01_biodata')),
    },
    {
        key: 'pendaftaran.mahasiswa.biodata.add',
        path: `${APP_PREFIX_PATH}/pendaftaran-mahasiswa/biodata/add`,
        component: React.lazy(() => import('views/v2/user/pendaftaran/01_biodata/add')),
    },
    {
        key: 'pendaftaran.mahasiswa.biodata.edit',
        path: `${APP_PREFIX_PATH}/pendaftaran-mahasiswa/biodata/edit`,
        component: React.lazy(() => import('views/v2/user/pendaftaran/01_biodata/edit')),
    },
    {
        key: 'pendaftaran.mahasiswa.biodata.detail',
        path: `${APP_PREFIX_PATH}/pendaftaran-mahasiswa/biodata/detail`,
        component: React.lazy(() => import('views/v2/user/pendaftaran/01_biodata/detail')),
    },


    {
        key: 'pendaftaran.mahasiswa.berkas_administrasi',
        path: `${APP_PREFIX_PATH}/pendaftaran-mahasiswa/berkas_administrasi`,
        component: React.lazy(() => import('views/v2/user/pendaftaran/02_berkas_administrasi')),
    },
    {
        key: 'pendaftaran.mahasiswa.pengumpulan_data',
        path: `${APP_PREFIX_PATH}/pendaftaran-mahasiswa/pengumpulan_data`,
        component: React.lazy(() => import('views/v2/user/pendaftaran/03_pengumpulan_data')),
    },
    {
        key: 'pendaftaran.mahasiswa.jadwal_seleksi',
        path: `${APP_PREFIX_PATH}/pendaftaran-mahasiswa/jadwal_seleksi`,
        component: React.lazy(() => import('views/v2/user/pendaftaran/04_jadwal_seleksi')),
    },
    {
        key: 'pendaftaran.mahasiswa.hasil_seleksi',
        path: `${APP_PREFIX_PATH}/pendaftaran-mahasiswa/hasil_seleksi`,
        component: React.lazy(() => import('views/v2/user/pendaftaran/05_hasil_seleksi')),
    },
    {
        key: 'pendaftaran.mahasiswa.daftar_ulang',
        path: `${APP_PREFIX_PATH}/pendaftaran-mahasiswa/daftar_ulang`,
        component: React.lazy(() => import('views/v2/user/pendaftaran/06_daftar_ulang')),
    },
    {
        key: 'pendaftaran.mahasiswa.ujian_online',
        path: `${APP_PREFIX_PATH}/pendaftaran-mahasiswa/ujian_online`,
        component: React.lazy(() => import('views/v2/user/pendaftaran/041_ujian_online')),
    },
    
    {
        key: 'pendaftaran.mahasiswa',
        path: `${APP_PREFIX_PATH}/v2/pendaftaran/mahasiswa`,
        component: React.lazy(() => import('views/v2/user/periode_pendaftaran/index')),
    },
    
    {
        key: 'ujian.tes',
        path: `${APP_PREFIX_PATH}/ujian/tes`,
        component: React.lazy(() => import('views/v2/user/pendaftaran/041_ujian_online/ujian_cbt')),
    },

];
